angular.module('qkr.inventory')
    .controller('inventoryController', ['$scope', '$uibModal', '$rootScope', '$location',
        '$routeSegment', 'merchantService', 'inventoryService', 'products', 'categories',
        'FormHelper', 'messageService', 'utils', 'appConfig', 'gettextCatalog', '$log',
        function($scope, $uibModal, $rootScope, $location, $routeSegment,
                 merchantService, inventoryService, products, categories,
                 FormHelper, messageService, utils, appConfig,
                 gettextCatalog, $log) {
    $scope.$routeSegment = $routeSegment;    // Used to know what we've
                                                // Selected
    $scope.products = [];
    $scope.productsLoaded = false;
    $scope.saving = false;
    $scope.productDisplayLimit = 50;
    $scope.categories = [];
    $scope.selectedCategoryId = -1;
    $scope.orderProp = '-dateCreated';    // Default order
    $scope.isOpenProduct = true;
    $scope.requiresReload = false;
    $scope.productName = '';
    $scope.isDepartmentManager = appConfig.isDepartmentManager;
    $scope.allowEditOnOutletLevel =
        merchantService.behaviour(merchantService.merchantInfo, 'inventoryPage.allowEditOnOutletLevel');
    $scope.disableExpression =
        merchantService.behaviour(merchantService.merchantInfo, 'inventoryPage.disableEditOnOutletLevel');
    $scope.isEditable = ((appConfig.isElevatedUser && (!appConfig.outletLevel || $scope.allowEditOnOutletLevel)) &&
        merchantService.behaviour(merchantService.merchantInfo, 'inventoryPage.allowEdit')) || $scope.isDepartmentManager;
    $scope.isCharityMerchant = merchantService.behaviour(merchantService.merchantInfo, 'inventoryPage.charityProduct');
    $scope.outletLevel = appConfig.outletLevel;
    $scope.showDeletedProducts = false;
    $scope.productTitleText = gettextCatalog.getString('Products');
    $scope.showProductsText = gettextCatalog.getString('View Deleted Products');

    const createCommonDialogModalInstance = function(title, confirmButtonName, confirmMsg, multiMsgArray) {
        const modalInstance = $uibModal.open({
            template: require('../../templates/common/modalDialog.html'),
            controller: 'commonModalDialogController',
            windowClass: 'fade',
            backdrop: 'static',
            resolve: {
                title() {
                    return title;
                },
                confirmButtonName() {
                    return confirmButtonName;
                },
                confirmMsg() {
                    return confirmMsg;
                },
                multiMsgArray() {
                    return multiMsgArray;
                }
            }
        });

        return modalInstance;
    };

    const reloadInventory = function() {
        $scope.products = [];
        $scope.productsLoaded = false;
        // Swap category if not on all products
        if ($scope.selectedCategoryId > -1 && $scope.selected && $scope.selected.category) {
            $scope.selectedCategoryId = $scope.selected.category.id;
        }
        inventoryService.invalidateCache();

        inventoryService.loadInventory(true).then((promise) => {
            $scope.products = promise;
            $scope.productsLoaded = true;
        }).catch(error => $log.error(error));

        // Load all the products
        $scope.reloadCategories();
    };
    
    const formHelper = new FormHelper($scope);

    $scope.init = function() {
        // Used to know what we've selected
        $scope.$routeSegment = $routeSegment;
        // Data is collected in 'inventory.confg.js' and injected above as 'products'.
        $scope.products = products;
        $scope.productsLoaded = true;
        $scope.categories = categories
            .filter((category) => category.numItems > 0);
        $scope.query = '';
        if (!utils.hasNoValue($rootScope.merchantInfo)) {
        	$scope.baseImgUrl = $rootScope.merchantInfo.baseImageUrl;
        }
    };

    $scope.showCreateFirstProduct = function() {
        // If there are no products, show the Create First Product div on
        // the outlet page for schools and merchant page for non-schools
        const showForOutlet = merchantService
            .behaviour(merchantService.merchantInfo, 'inventoryPage.showCreateFirstProduct'); // == School
        const noProds = $scope.products.length === 0;
        const outletLevel = $scope.outletLevel;

        return (showForOutlet && outletLevel && noProds) || (!outletLevel && noProds);
    };

    $scope.hideCreateProduct = function() {
        return merchantService
            .behaviour(merchantService.merchantInfo, 'inventoryPage.hideCreateProduct');
    };

    $scope.showStock = function() {
        if (merchantService.behaviour(merchantService.merchantInfo, 'inventoryPage.showStock')) { // == School
            return true;
        } else if (inventoryService.isStockLevelTrackingEnabled($scope.outletLevel, $scope.products)) {
            return true;
        }

        return false;
    };

    // Disable or enable a product by clicking the button in the list
    $scope.disableOrEnableProduct = function(selectedProduct) {
        inventoryService.findInventoryItemInMenus(selectedProduct.id).then((promise) => {
            const multiMsgArray = [];
            const listOfMenus = promise;
            const action = selectedProduct.offline ? 'show' : 'hide';
            const extra = selectedProduct.offline ? '' :
                gettextCatalog.getString('It will no longer be available on Qkr!');
            let confMsg = gettextCatalog.getString('Are you sure you want to ') + action + ' \''
                                                                                + selectedProduct.name + '\'? ' + extra;
            if (listOfMenus.length > 0) {
                confMsg = confMsg + (listOfMenus.length > 1 ? gettextCatalog.getString(' This will affect the following menus: ')
                                                            : gettextCatalog.getString(' This will affect the menu: '))
                    + utils.summarizeListWithMenuNames(listOfMenus, 2) + '\'';
            }

            if (!selectedProduct.offline) {
                multiMsgArray.push(gettextCatalog.getString('To unhide product, click on the down arrow to the right of the edit button and select \'Show\'.'));
            }
            
            const modalInstance = createCommonDialogModalInstance(
                gettextCatalog.getString('Set') + ' ' + action
                                                + gettextCatalog.getString(' to ') + selectedProduct.name,
                gettextCatalog.getString('Confirm'),
                confMsg,
                multiMsgArray
            );

            modalInstance.result.then((result) => {
                if (result === 'ok') {
                	if (!selectedProduct.offline) {
	                	inventoryService.hideProduct(selectedProduct).then((promise) => {
	                       	$scope.saveProductCallback(promise);
	                    }, (promise) => {
	                       	$scope.saveProductCallback(promise);
	                    }).catch(error => $log.error(error));
                	} else {
                		inventoryService.unhideProduct(selectedProduct).then((promise) => {
	                       	$scope.saveProductCallback(promise);
	                    }, (promise) => {
	                       	$scope.saveProductCallback(promise);
	                    }).catch(error => $log.error(error));
                	}
                } 
            }, () => {});
        }).catch(error => $log.error(error));
    };

    // Handle response from attempted save
    $scope.saveProductCallback = function(response) {
        if (response) {
            const r = formHelper.handleResponse(response);
            if (r.isSuccess()) {
                $scope.products = [];
                $scope.productsLoaded = false;
                inventoryService.invalidateCache();
                inventoryService.loadInventory(true).then((data) => {
                    $rootScope.$broadcast('newProducts', data);
                    $scope.products = data;
                    $scope.productsLoaded = true;
                }).catch(error => $log.error(error));

                $scope.reloadCategories();

                messageService.saveAlert();
            } else {
                messageService.error(
                    gettextCatalog.getString('A problem was encountered when saving. Please try again.'));
            }
        }
    };

    $scope.updateSelectedProduct = function(selectedProduct) {
        inventoryService.updateProduct(selectedProduct, null, null, null).then((promise) => {
            $scope.saveProductCallback(promise);
        }, (promise) => {
            $scope.saveProductCallback(promise);
        }).catch(error => $log.error(error));
    };

    // Mark a product as deleted - User can't see it again but will be seen in deleted product page
    $scope.removeProduct = function(selectedProduct) {
        inventoryService.findInventoryItemInMenus(selectedProduct.id).then((promise) => {
            const listOfMenus = promise;

            let confMsg = gettextCatalog.getString('Are you sure you want to delete') +
                ' \'' + selectedProduct.name + '\'? ' +
                gettextCatalog.getString('It will no longer be displayed to Qkr users!');
            if (listOfMenus.length > 0) {
                confMsg = confMsg + utils.summarizeListWithCouponAndMenuNames(listOfMenus, true);
            }
            const msgArray = confMsg.split('\n');
            msgArray.push(
                gettextCatalog.getString('You will be able to restore this product on the Deleted Products page.'));

            const modalInstance = createCommonDialogModalInstance(
                gettextCatalog.getString('Delete') + ' ' + selectedProduct.name,
                gettextCatalog.getString('Delete'),
                null, // ConfMsg,
                msgArray
            );
        	
            modalInstance.result
                .then(result => result === 'ok' ? doRemoveProduct(selectedProduct) : Promise.resolve())
                .then(saveProduct => $scope.saveProductCallback(saveProduct))
                .catch(error => $log.error(error));
        }).catch(error => $log.error(error));
    };

    const doRemoveProduct = function(selectedProduct) {
        selectedProduct.deleted = true;
        $rootScope.$broadcast('reloadDashboard');
        if (selectedProduct.accType === null) {
            $rootScope.undefinedProducts--;
        }
        return inventoryService.removeProduct(selectedProduct);
    };

    // Mark a product as permanent deleted - will never be seen again in MSS
    $scope.trashProduct = function(selectedProduct) {
        const confMsg = gettextCatalog.getString('Are you sure you want to trash') +
            ' \'' + selectedProduct.name + '\'? ' +
            gettextCatalog.getString('You will not be able to restore this product!');

        const msgArray = confMsg.split('\n');

        const modalInstance = createCommonDialogModalInstance(
            gettextCatalog.getString('Trash') + ' ' + selectedProduct.name,
            gettextCatalog.getString('Trash'),
            null, // ConfMsg,
            msgArray
        );

        modalInstance.result
            .then(result => result === 'ok' ? inventoryService.trashProduct(selectedProduct) : Promise.resolve())
            .then(saveProduct => $scope.saveProductCallback(saveProduct))
            .catch(error => $log.error(error));
    };

    $scope.restoreProduct = function(selectedProduct) {
        inventoryService.findInventoryItemInMenus(selectedProduct.id).then((promise) => {
            const listOfMenus = promise;

            let confMsg = gettextCatalog.getString('Are you sure you want to restore') +
                ' \'' + selectedProduct.name + '\'? ';
            if (!utils.hasNoValue(listOfMenus)) {
                confMsg = confMsg + utils.summarizeListWithCouponAndMenuNames(listOfMenus, false);
            }
            const msgArray = confMsg.split('\n');

            const modalInstance = createCommonDialogModalInstance(
                gettextCatalog.getString('Restore') + ' ' + selectedProduct.name,
                gettextCatalog.getString('Restore'),
                null, // ConfMsg,
                msgArray
            );

            modalInstance.result
                .then(result => result === 'ok' ? doRestoreProduct(selectedProduct) : Promise.resolve())
                .then(saveProduct => $scope.saveProductCallback(saveProduct))
                .catch(error => $log.error(error));
        }).catch(error => $log.error(error));
    };

    const doRestoreProduct = function(selectedProduct) {
        selectedProduct.deleted = false;
        $rootScope.$broadcast('reloadDashboard');
        if (selectedProduct.accType === null) {
            $rootScope.undefinedProducts++;
        }
        return inventoryService.restoreProduct(selectedProduct);
    };

    $scope.showProductModal = function(prod, productIsNew, productIsCloned) {
        const modalInstance = $uibModal.open({
            template: require('../templates/inventoryItem.html'),
            controller: 'InventoryItemEditController',
            windowClass: 'modal-huge',
            backdrop: 'static',
            resolve: {
                prod() {
                    return prod;
                },
                isNewProduct() {
                    return productIsNew;
                },
                isClonedProduct() {
                    return productIsCloned;
                }
            }
        });

        modalInstance.result.then((selectedItem) => {
            $scope.selected = selectedItem;
            reloadInventory();
        }, () => { 
        	reloadInventory();
        	}).catch(error => $log.error(error));
    };

    // Edit an existing product
    // Copies and shows modal
    $scope.editProduct = function(product, isClone) {
    	if (isClone === true) {
            $location.path('/inventoryItem/clone/' + product.id);
        } else {
            $location.path('/inventoryItem/edit/' + product.id);
        }
    };

    // Enable custom ordering
    $scope.customOrder = function(product) {
        switch ($scope.orderField) {
            case 'Name':
            case 'Sort By':
                return product.name;
            case 'Price':
                return product.amountMinorUnits;
        }
    };

    // Set the baseImageUrl using the merchant object in the first product
    // $scope.$watch('products', () => {
    //     if (typeof $scope.products[0] !== 'undefined') {
    //
    //     }
    // });

    // The product list has been reloaded
    $scope.$on('MerchantInfoLoaded', (evt, args) => {
        inventoryService.fixImageUrls();
    });
    // The product list has been reloaded
    $scope.$on('newProducts', (evt, args) => {
        $scope.products = args;
    });

    // The category list has been reloaded
    $scope.$on('newCategories', (evt, args) => {
        $scope.categories = args;
        
        const noempty = [];
        for (let i = 0; i < $scope.categories.length; i++) {
            if ($scope.categories[i].numItems !== 0) {
                noempty.push($scope.categories[i]);
            } else if ($scope.selectedCategoryId === $scope.categories[i].id) {
                // If the category has been emptied put the user on the all
                // Categories view
                $scope.selectedCategoryId = -1;
            }
        }
        $scope.categories = noempty;
    });

    $scope.reloadCategories = function() {
        if ($scope.showDeletedProducts) {
            inventoryService.loadProductCategoriesForDeletedInventory().then((promise) => {
                $scope.categories = promise.filter((category) => category.numItems > 0);
            }).catch(error => $log.error(error));
        } else {
            inventoryService.loadProductCategoriesForInventory().then((promise) => {
                $scope.categories = promise.filter((category) => category.numItems > 0);
            }).catch(error => $log.error(error));
        }

        if ($scope.categories.indexOf($scope.selectedCategoryId) === -1) {
            $scope.selectedCategoryId = -1;
        }
    };

    // The user selects a category
    $scope.selectCategory = function(selCategory) {
        if ($scope.selectedCategoryId === selCategory)
            $scope.selectedCategoryId = -1; // Deselect
        else
            $scope.selectedCategoryId = selCategory;
    };

    $scope.styleIndicator = function(value) {
        const col = (value.id === $scope.selectedCategoryId) ? 'FFF' : value.colour;
        return {'background-color': '#' + col};
    };

    $scope.styleRow = function(value) {
        const col = (value.id === $scope.selectedCategoryId) ? value.colour : value.colour;
        return {'background-color': '#' + col};
    };

    $scope.updateProductStockLevel = function(prod) {
        if (prod.variants.length === 1) {
            prod.variants[0].quantityAvailable = prod.quantityAvailable;
            $scope.updateVariantStockLevel(prod, prod.variants[0]);
        }
    };

    $scope.updateVariantStockLevel = function(prod, variant) {
        inventoryService.updateVariantStockLevel(variant, $rootScope.outletInfo.id, variant.quantityAvailable)
            .then((data) => {
                let totalStockCount = 0;
                angular.forEach(prod.variants, (variant) => {
                    totalStockCount += parseInt(variant.quantityAvailable);
                });

                prod.quantityAvailable = totalStockCount;
        }).catch(error => $log.error(error));
    };
    
    $scope.refreshProductList = function() {
    	reloadInventory();
    };

    // Switch between normal products and deleted products
    $scope.switchProducts = function() {
        if ($scope.showDeletedProducts === true) {
            // Switch to normal product view
            $scope.productTitleText = gettextCatalog.getString('Products');
            $scope.showProductsText = gettextCatalog.getString('View Deleted Products');
            $scope.showDeletedProducts = false;
            inventoryService.loadProductCategoriesForInventory().then((promise) => {
                $scope.categories = promise.filter((category) => category.numItems > 0);
            }).catch(error => $log.error(error));
        } else {
            // Switch to deleted product view
            $scope.productTitleText = gettextCatalog.getString('Deleted Products');
            $scope.showProductsText = gettextCatalog.getString('Back to Products');
            $scope.showDeletedProducts = true;
            inventoryService.loadProductCategoriesForDeletedInventory().then((promise) => {
                $scope.categories = promise.filter((category) => category.numItems > 0);
            }).catch(error => $log.error(error));
        }

        // Revert selected category to All Categories when switch
        $scope.selectedCategoryId = -1;
    };
}]);




// WEBPACK FOOTER //
// ./src/inventory/controllers/inventory.controller.js